// components/domain-assignment/components/ActivityMarkdown.js
import React from 'react';
import ReactMarkdown from 'react-markdown';

const ActivityMarkdown = ({ content, className = "" }) => {
  if (!content) return null;

  return (
    <div className={className}>
      <ReactMarkdown
        components={{
          h1: ({node, ...props}) => (
            <h1 className="text-2xl font-bold my-4 text-gray-900" {...props} />
          ),
          h2: ({node, ...props}) => (
            <h2 className="text-xl font-semibold my-3 text-gray-900" {...props} />
          ),
          h3: ({node, ...props}) => (
            <h3 className="text-lg font-medium my-2 text-gray-900" {...props} />
          ),
          p: ({node, ...props}) => (
            <p className="my-2 text-gray-700" {...props} />
          ),
          ul: ({node, ...props}) => (
            <ul className="list-disc ml-5 my-2" {...props} />
          ),
          ol: ({node, ...props}) => (
            <ol className="list-decimal ml-5 my-2" {...props} />
          ),
          li: ({node, ...props}) => (
            <li className="my-1" {...props} />
          ),
          blockquote: ({node, ...props}) => (
            <blockquote className="border-l-4 border-gray-300 pl-4 italic my-3 text-gray-600" {...props} />
          ),
          strong: ({node, ...props}) => (
            <strong className="font-semibold text-gray-900" {...props} />
          ),
          em: ({node, ...props}) => (
            <em className="italic" {...props} />
          ),
          code: ({node, ...props}) => (
            <code className="bg-gray-100 rounded px-1 py-0.5 font-mono text-sm" {...props} />
          ),
          pre: ({node, ...props}) => (
            <pre className="bg-gray-100 rounded p-3 font-mono text-sm my-3 overflow-x-auto" {...props} />
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default ActivityMarkdown;